"use client";

import React from "react";
import EditSection, {
  TextEditor,
  ListItemEditor,
} from "../../sections/shared/EditSection";
import { SectionContentProps } from "../../types";

export default function HokCtaEdit({
  content,
  onContentChange,
}: SectionContentProps) {
  const handleChange = (updated: Record<string, any>) => {
    onContentChange?.(updated);
  };

  return (
    <EditSection
      content={content}
      onContentChange={handleChange}
      contentFields={
        <>
          {/* CTA Cards */}
          <div className="p-3 bg-gray-50 rounded-lg space-y-3">
            <h4 className="text-xs font-semibold text-gray-700">CTA Cards</h4>
            <ListItemEditor
              label="Cards"
              items={content.cards || [
                { title: "Want to Sell?", subtitle: "Open a Vendor Store", buttonText: "Start Selling", icon: "store" },
                { title: "Looking for Assets?", subtitle: "Browse Premium Themes", buttonText: "Explore Now", icon: "theme" },
              ]}
              itemSchema={[
                { key: "title", label: "Title", type: "text" },
                { key: "subtitle", label: "Subtitle", type: "text" },
                { key: "buttonText", label: "Button Text", type: "text" },
                { key: "url", label: "URL", type: "text" },
              ]}
              onChange={(items) => handleChange({ ...content, cards: items })}
              addItemText="Add Card"
            />
          </div>
        </>
      }
    />
  );
}
